module.exports = __webpack_public_path__ + "img/sale_banner2.3c917088.png";